import BaseUIReportHelperSales from 'xui/modules/report/BaseUIReportHelperSales'
import * as util from '../../utils/util-web'

export default class ReportHelperSales extends BaseUIReportHelperSales {
  _handleOnDownloadFileByPlatform = async (url: string, fileName: string): Promise<void> => {
    if (url) {
      await util.downloadFileFromUrl({ url, fileName })
    }
  }
}
